// type TagEnum = 'success' | 'info' | 'warning' | 'danger' | 'cyan' | 'blue' | 'red' | 'orange' | 'green' | 'gray'

export var statusOptions = [{
  value: 1,
  label: '启用',
  tag: 'green'
}, {
  value: 0,
  label: '禁用',
  tag: 'red'
}];
export var appCategoryOptions = [{
  value: 1,
  label: '抽奖助手',
  tag: 'default'
}, {
  value: 2,
  label: 'AI算命',
  tag: 'warning'
}, {
  value: 3,
  label: '阅读赚钱',
  tag: 'cyan'
}];
export var appTypeOptions = [{
  value: 1,
  label: '小程序',
  tag: 'green'
}, {
  value: 2,
  label: '公众号',
  tag: 'blue'
}, {
  value: 3,
  label: 'H5',
  tag: 'cyan'
}];
export var defaultFormData = {
  appName: '',
  // 应用名称
  appCategory: '',
  // 应用分类
  appType: '',
  // 应用类型
  appId: '',
  // 小程序appid
  appSecret: '',
  // 小程序密钥
  domain: '',
  // 域名
  publicWechatName: '',
  // 微信公众号名称
  publicWechatAppid: '',
  // 微信公众号appid
  publicWechatSecret: '',
  // 微信公众号密钥
  verifyToken: '',
  // 微信验证Token
  encodingAesKey: '',
  // EncodingAESKey
  encryptionMethod: 0,
  // 微信消息加密方式

  newUserRewardEnabled: 0,
  // 新人奖励开关
  newUserRewardType: 1,
  // 新人奖励类型
  newUserRewardAmount: 0,
  // 新人奖励数值
  popupId: '',
  // 客服id
  readChannelId: '',
  // 阅读渠道id
  wxPayReceiveChannelId: '',
  // 微信收款支付渠道id
  wxPayWithdrawChannelId: '',
  // 微信提现支付渠道id
  aliPayReceiveChannelId: '',
  // 支付宝收款支付渠道id
  aliPayWithdrawChannelId: '',
  // 支付宝提现支付渠道id

  status: 1 // 状态
};
export var formRules = {
  appName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入应用名称'
  }],
  appCategory: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择应用分类'
  }],
  appType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择应用环境'
  }],
  appId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入小程序appid'
  }],
  appSecret: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入小程序密钥'
  }],
  popupId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择客服'
  }],
  domain: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入域名'
  }],
  publicWechatName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信公众号名称'
  }],
  publicWechatAppid: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信公众号appid'
  }],
  publicWechatSecret: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信公众号密钥'
  }],
  verifyToken: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入微信验证Token'
  }],
  encodingAesKey: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入EncodingAESKey'
  }],
  encryptionMethod: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择微信消息加密方式'
  }],
  wxPayReceiveChannelId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择微信收款支付渠道'
  }],
  wxPayWithdrawChannelId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择微信提现支付渠道'
  }],
  aliPayReceiveChannelId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择支付宝收款支付渠道'
  }],
  aliPayWithdrawChannelId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择支付宝提现支付渠道'
  }]
};